type Props = React.ComponentProps<"svg"> & {
	size?: string | number;
};
export const ThicknessIcon = ({ size = 16, ...props }: Props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			{...props}
		>
			<circle cx="12.5" cy="3.5" r="1.5" fill="#0E0E0E" />
			<circle cx="3.5" cy="3.5" r="1.5" fill="#0E0E0E" />
			<path d="M5.5 5.5L13 13" stroke="#0E0E0E" strokeLinecap="round" />
			<path d="M10.5 5.5L9 7" stroke="#0E0E0E" strokeLinecap="round" />
			<path d="M7 9L3 13" stroke="#0E0E0E" strokeLinecap="round" />
		</svg>
	);
};
